const UNITS: readonly [Intl.RelativeTimeFormatUnit, number][] = [
	["year", 365 * 24 * 60 * 60],
	["month", 30 * 24 * 60 * 60],
	["week", 7 * 24 * 60 * 60],
	["day", 24 * 60 * 60],
	["hour", 60 * 60],
	["minute", 60]
];

/** "2 hours ago", "3 weeks ago", "now" — the design's "Updated …" metadata. */
export const formatRelativeTime = (date: Date, locale: string, now: Date = new Date()): string => {
	const format = new Intl.RelativeTimeFormat(locale, { numeric: "auto" });
	const seconds = Math.round((date.getTime() - now.getTime()) / 1000);
	for (const [unit, unitSeconds] of UNITS) {
		if (Math.abs(seconds) >= unitSeconds) return format.format(Math.trunc(seconds / unitSeconds), unit);
	}
	return format.format(0, "second");
};
